const header = document.querySelector('.pageHeader') as HTMLElement;
const headerInner = document.querySelector('.pageHeader__inner') as HTMLElement;
const mainMenuWrapper = document.querySelector('.nav--primary');
const menuItems = document.querySelectorAll<HTMLElement>('.nav--primary li');

const animatedBgMenuElement = document.createElement('div');
animatedBgMenuElement.classList.add('pageHeader--animatedBgMenuElement');
header.prepend(animatedBgMenuElement);

// create toggle buttons and add them to the primary nav in the header
function buildButtons() {
	menuItems.forEach((menuItem) => {
		if (menuItem.classList.contains('node--hasChild')) {
			const buttonElem = document.createElement('button');
			const menuItemText = menuItem.querySelector('span')?.textContent;
			buttonElem.innerText = `Show submenu for ${menuItemText}`;
			buttonElem.setAttribute('aria-expanded', 'false');
			buttonElem.setAttribute('aria-controls',
				menuItem.querySelector('span')?.textContent!.trim().replace(/\s+/g, '-').toLowerCase() + '-submenu');
			buttonElem.classList.add('node--buttonToggle');
			buttonElem.addEventListener('click', function () {
				toggleMegaMenu.call(this); // Toggle the menu
			});
			menuItem.insertBefore(buttonElem, menuItem.querySelector('.childWrap'));
		}
	});
}

let isMenuOpen = false; // Track whether the mega menu is open
let activeItem: HTMLElement | null = null; // Track the currently active menu item

function toggleMenuItems(item: HTMLElement) {
	// get all accessible items related to active item
	const wrappingLi = item.closest('li');
	if (!wrappingLi) {
		return;
	}

	const accessibleNavItems = wrappingLi.querySelectorAll('.nav--primary [aria-expanded]');
	// get the child list item
	const childItem = wrappingLi.querySelector('.childWrap--hasDescription');
	if (!childItem) return;

	// get nav item text
	const navItemText = wrappingLi.querySelector('span')?.textContent;
	// get button
	const navItemButton = wrappingLi.querySelector('button');

	if (childItem.classList.contains('activeChildItem')) {
		childItem.classList.remove('activeChildItem');

		accessibleNavItems.forEach((accessibleItem) => {
			accessibleItem.setAttribute('aria-expanded', 'false');
		});

		if (navItemButton) {
			navItemButton.innerText = `Show submenu for ${navItemText}`;
		}

		isMenuOpen = false;
		activeItem = null;
	} else {
		// Close the previously active item if it exists
		if (activeItem && activeItem !== item) {
			toggleMenuItems(activeItem);
			const extraDiv = document.querySelector<HTMLElement>('.pageHeader--animatedBgMenuElement');
			if (extraDiv) {
				extraDiv.style.opacity = '1';
			}
		}

		childItem.classList.add('activeChildItem');
		for (const accessibleItem of accessibleNavItems) {
			accessibleItem.setAttribute('aria-expanded', 'true');
		}

		if (navItemButton) {
			navItemButton.innerText = `Hide submenu for ${navItemText}`;
		}

		isMenuOpen = true;
		activeItem = item;
	}

	const childItemHeight = childItem.getBoundingClientRect().height;
	document.documentElement.style.setProperty(
		'--pageHeader-psuedo-bottom',
		isMenuOpen ? '-' + childItemHeight + 'px' : '0'
	);
}

function fadeInBackground() {
	if (!isMenuOpen) {
		header.classList.add('background-fade');
	}
}

function fadeOutBackground() {
	if (!isMenuOpen) {
		header.classList.remove('background-fade');
	}
}

function toggleMegaMenu(this: HTMLElement) {
	if (isMenuOpen) {
		hideMegaMenu.call(this); // Close the menu if it's open
	} else {
		showMegaMenuWithAnimations.call(this); // Open the menu if it's closed
	}
}

function showMegaMenuWithAnimations(this: HTMLElement) {
	if (!isMenuOpen && (this.classList.contains('node--hasChild') || this.classList.contains('node--buttonToggle'))) {
		const extraDiv = document.querySelector<HTMLElement>('.pageHeader--animatedBgMenuElement');
		if (extraDiv) {
			extraDiv.style.opacity = '1';
		}

		toggleMenuItems(this);

		const listItems = this.querySelectorAll<HTMLElement>('li.node');
		listItems.forEach((listItem: HTMLElement, index: any) => {
			listItem.style.animationDelay = ((index + 1) * 0.05).toString() + 's';
		});
	}
}

function hideMegaMenu(this: HTMLElement) {
	if (
		(isMenuOpen && this.classList.contains('node--hasChild')) ||
		(isMenuOpen && this.classList.contains('node--buttonToggle'))
	) {
		const extraDiv = document.querySelector<HTMLElement>('.pageHeader--animatedBgMenuElement');
		if (extraDiv) {
			extraDiv.style.opacity = '0';
		}

		toggleMenuItems(this);
	}
}

header.addEventListener('mouseenter', fadeInBackground);
header.addEventListener('mouseleave', fadeOutBackground);

menuItems.forEach(item => {
	item.addEventListener('pointerenter', function (event) {
		if (event.pointerType === 'mouse') {
			showMegaMenuWithAnimations.call(this);
		}
	});
	item.addEventListener('pointerleave', function (event) {
		if (event.pointerType === 'mouse') {
			hideMegaMenu.call(this); // Call the function with the current context
		}
	});
});

// Add event listeners to close menu on focusout and click events
document.addEventListener('focusout', function (event) {
	if (activeItem && !event.relatedTarget) {
		// Close the menu when the focus goes outside
		toggleMenuItems(activeItem);
	}
});

document.addEventListener('click', function (event) {
	const target = event.target as HTMLElement;
	if (activeItem && !target.closest('.node--buttonToggle')) {
		// Close the menu when clicking outside the button toggles
		toggleMenuItems(activeItem);
	}
});

// Initial setup
function setUpMegaMenu() {
	buildButtons();

	// TODO: create the 'active' marker and add functionality
	// const markerElWrap = document.createElement('div');
	//     // markerElWrap.classList.add('markerWrap');
	//     // const markerEl = document.createElement('span');
	//     // markerEl.classList.add('marker');
	//     // markerElWrap.appendChild(markerEl);
	//     // mainMenuWrapper.prepend(markerElWrap);

	if (menuItems.length > 0) {
		// Your setup code here
	} else {
		return;
	}
}

setUpMegaMenu();
